import React from 'react';
import { ArrowDownUp, Clock, Trophy, Sparkles } from 'lucide-react';
import FilterModalWrapper from './FilterModalWrapper';

/**
 * SortModal - Desktop modal for selecting fixture sort order
 * Provides options for smart, time, or league sorting
 * Adapted from mobile SortSheet
 *
 * @param {boolean} isOpen - Whether modal is open
 * @param {Function} onClose - Callback to close modal
 * @param {string} currentSort - Currently selected sort option
 * @param {Function} onSortChange - Callback when sort is selected
 */
const SortModal = ({
  isOpen,
  onClose,
  currentSort,
  onSortChange
}) => {
  const sortOptions = [
    { id: 'smart', label: 'Smart Sort', icon: Sparkles, description: 'Intelligent fixture ordering' },
    { id: 'time', label: 'By Time', icon: Clock, description: 'Sort by kick-off time' },
    { id: 'league', label: 'By League', icon: Trophy, description: 'Group by competition' }
  ];

  const handleSortSelect = (sortId) => {
    onSortChange(sortId);
  };

  return (
    <FilterModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Sort By"
      icon={ArrowDownUp}
      maxWidth="sm"
      maxHeight="50vh"
    >
      {/* Sort Options */}
      <div className="p-4">
        {sortOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = currentSort === option.id;

          return (
            <button
              key={option.id}
              onClick={() => handleSortSelect(option.id)}
              className={`
                w-full flex items-center gap-3 p-3 rounded-lg transition-all mb-2
                ${isSelected
                  ? 'bg-emerald-500/20 border border-emerald-500/50'
                  : 'hover:bg-gray-800/50 border border-transparent'
                }
              `}
            >
              <div className={`
                p-2 rounded-lg
                ${isSelected ? 'bg-emerald-500/20' : 'bg-gray-800'}
              `}>
                <Icon className={`
                  w-5 h-5
                  ${isSelected ? 'text-emerald-400' : 'text-gray-400'}
                `} />
              </div>

              <div className="flex-1 text-left">
                <div className={`
                  font-medium text-sm
                  ${isSelected ? 'text-emerald-400' : 'text-white'}
                `}>
                  {option.label}
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  {option.description}
                </div>
              </div>

              {isSelected && (
                <div className="w-2 h-2 rounded-full bg-emerald-400" />
              )}
            </button>
          );
        })}
      </div>
    </FilterModalWrapper>
  );
};

export default SortModal;
